<template>
    <div class="detailInfo-pack info-pack"
         :class="[`col-${col}`, `label-${labelType}`]">
        <div v-show="title"
             class="title">{{$t(title)}}
            <slot name="titleR"></slot>
        </div>
        <ul>
            <slot></slot>
            <!-- 空标签有用， 勿删 -->
            <li></li>
            <li></li>
        </ul>
    </div>
</template>

<script>
// 表格类详细信息
export default {
    name: 'detailinfo',
    props: {
        title: {
            type: String,
            default: ''
        },
        col: {
            type: String,
            default: '3'
            // 3:三列， 2:两列(两列的时候label默认为150px)
        },
        labelType: {
            type: String,
            default: 'default'
            // label的宽度，默认80px, 'max':待定；'second': 100px； 'initial': 无宽度（即不用按照：对齐）
        }
    },
    data () {
        return {}
    },
    created () {
    },
    methods: {
    }
}
</script>
<style lang="less">
.detailInfo-pack {
    position: relative;
    // &>.title {
    //     height: 40px;
    //     font-size: 12px;
    //     line-height: 40px;
    //     font-weight: bold;
    //     color: #000;
    //     border-bottom: 1px dashed #e9e9e9;
    // }
    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    & > ul {
        padding: 10px 0;
        display: flex;
        flex-wrap: wrap;

        //小屏自动换行
        li {
            list-style: none;
            width: 33.33%;
            font-size: 12px;
            // height: 35px;
            line-height: 35px;
            padding-left: 9px;
            color: #333;
            display: flex;
            overflow: hidden;
            white-space: nowrap;
            min-width: 200px;
            // flex-grow: 1;
            .label {
                display: inline-block;
                // width: 80px;
                text-align: right;
                flex-shrink: 0;
                color: #808080;
            }
        }
    }

    &.col-2 {
        & > ul > li {
            width: 50%;
            min-width: 300px;

            .label {
                width: 150px;
            }
        }
    }
    &.col-1 {
        & > ul {
            display: block;
            & > li {
                width: 100%;
            }
        }
    }
    &.label-default > ul > li {
        .label {
            min-width: 100px;
        }
    }
    &.label-second > ul > li {
        .label {
            width: 100px;
        }
    }
    &.label-max > ul > li {
        .label {
            width: 150px;
        }
    }
    // &.label-initial{
    //     .label {
    //         width: initial;
    //     }
    // }
}
</style>
